/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Valid_SubscriptionInputs */

const en_plan_valid_subscription = /** @type {(inputs: Plan_Valid_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid Subscription`)
};

const es_plan_valid_subscription = /** @type {(inputs: Plan_Valid_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción válida`)
};

/**
* | output |
* | --- |
* | "Valid Subscription" |
*
* @param {Plan_Valid_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_valid_subscription = /** @type {((inputs?: Plan_Valid_SubscriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Valid_SubscriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_valid_subscription(inputs)
	return en_plan_valid_subscription(inputs)
});